import { SingleValue } from 'react-select';

import {
  FilterOperator,
  FILTER_OPERATORS,
  OPERATORS_WITHOUT_VALUE,
  DataWidgetFiltersInput,
} from 'dashboards/types/filter';

import { formatPretty } from 'services/string';

import { Select } from 'components/Select/Select';

import { useDataWidgetFiltersInputState } from './context';

const operatorOptions: OperatorOption[] = FILTER_OPERATORS.map((value) => ({
  value,
  label: formatPretty(value).toLowerCase(),
}));

type OperatorOption = {
  value: FilterOperator;
  label: string;
};

type OperatorInputProps = Omit<DataWidgetFiltersInput, 'value'>;

export function OperatorInput({ id, column, operator }: OperatorInputProps) {
  const { columns, updateFilter } = useDataWidgetFiltersInputState();

  const type = columns.find(({ name }) => name === column)?.datatype;

  function isOptionDisabled(operator: OperatorOption) {
    switch (type) {
      case 'BOOLEAN':
      case 'JSON':
        return [
          'GREATER_THAN',
          'GREATER_THAN_OR_EQUAL_TO',
          'LESS_THAN',
          'LESS_THAN_OR_EQUAL_TO',
        ].includes(operator?.value);
      default:
        return false;
    }
  }

  function handleOperatorChange(operator: SingleValue<OperatorOption>) {
    if (!operator?.value) {
      return;
    }

    // Clear value when switching to operators without value
    if (OPERATORS_WITHOUT_VALUE.includes(operator.value)) {
      updateFilter(id, { operator: operator.value, value: '' });
      return;
    }

    updateFilter(id, { operator: operator.value });
  }

  return (
    <Select
      defaultValue={operatorOptions.find(({ value }) => value === operator)}
      onChange={handleOperatorChange}
      options={operatorOptions}
      isOptionDisabled={isOptionDisabled}
    />
  );
}
